import { render } from "./DownloadFile.vue?vue&type=template&id=466d2fe8"
import script from "./DownloadFile.vue?vue&type=script&lang=js"
export * from "./DownloadFile.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__